<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    @click="$emit('click')"
  >
    <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "AccountCheckIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
